import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { messages } from '../../../fulfillment-planner/labeled-row/messages';

import { LabeledRow } from '../../../fulfillment-planner/labeled-row';
import Carrier from './carrier';
import style from './style.module.css';

const ExternalFulfillmentCarrier = ({ carrierId, carrierName }) => {
  if (!carrierName) {
    return <Carrier carrierId={carrierId} />;
  }

  return (
    <LabeledRow className={style.row} label={<FormattedMessage {...messages.carrier} />} labelClassName={style.label}>
      {carrierName}
    </LabeledRow>
  );
};

ExternalFulfillmentCarrier.propTypes = {
  carrierId: PropTypes.string,
  carrierName: PropTypes.string,
};

export default ExternalFulfillmentCarrier;
